function scrollBehavior(to, from, savedPosition) {
  if (savedPosition) {
    return savedPosition;
  }

  // Preserve scroll position when navigating between menu and menu item detail pages
  // This prevents the page from resetting when opening/closing menu item modals
  const menuRoutes = ['orderMenu', 'orderAtTableMenu'];
  const menuItemRoutes = ['orderAheadMenuItemDetailsPage', 'orderAtTableMenuItemDetailsPage'];

  // Going from menu to menu item detail (opening modal)
  if (menuRoutes.includes(from.name) && menuItemRoutes.includes(to.name)) {
    return false; // Don't scroll, preserve current position
  }

  // Going from menu item detail back to menu (closing modal)
  if (menuItemRoutes.includes(from.name) && menuRoutes.includes(to.name)) {
    return false; // Don't scroll, preserve current position
  }

  return { x: 0, y: 0 };
}



export default scrollBehavior;
